import axios from 'axios';

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;

const client = axios.create({ baseURL: BACKEND_URL });

export interface AppSummary {
  slug: string;
  name: string;
  repo_url: string | null;
  description: string | null;
  updated_at: string;
}

export interface PageTreeNode {
  slug: string;
  title: string;
  hasContent: boolean;
  children: PageTreeNode[];
}

export interface AppTree extends AppSummary {
  tree: PageTreeNode[];
}

export interface PageSummary {
  slug: string;
  title: string;
}

export interface Page {
  title: string;
  content: string;
  breadcrumb: PageSummary[];
  prev: PageSummary | null;
  next: PageSummary | null;
  updated_at: string;
}

export const listApps = async (): Promise<AppSummary[]> => {
  const { data } = await client.get<AppSummary[]>('/api/apps');
  return data;
};

export const getAppTree = async (slug: string): Promise<AppTree> => {
  const { data } = await client.get<AppTree>(`/api/apps/${slug}`);
  return data;
};

export const getPage = async (slug: string, pagePath: string[]): Promise<Page> => {
  const { data } = await client.get<Page>(`/api/apps/${slug}/pages/${pagePath.join('/')}`);
  return data;
};
